import { BrandAutocomplete } from '@/contexts/shared/components/inputs'
import CustomTextField from '@/contexts/shared/components/inputs/CustomTextField'
import { Grid } from '@mui/material'

interface NewsModalHeaderProps {
  newState: any
  handleInputChange: (inputName: string, value: any) => void
}

export const NewsModalHeader = ({ newState, handleInputChange }: NewsModalHeaderProps) => {
  return (
    <Grid container direction="row" alignItems="flex-start" justifyContent="space-between" spacing={2}>
      <Grid item xs={12} md={8}>
        <CustomTextField inputName="title" value={newState.title} handleInputChange={handleInputChange} required />
      </Grid>
      <Grid item xs={12} md={4}>
        <BrandAutocomplete value={newState.brand} handleInputChange={handleInputChange} />
      </Grid>
    </Grid>
  )
}
